import { render, staticRenderFns } from "./certificateTypeManager.vue?vue&type=template&id=4aa2874a"
import script from "./certificateTypeManager.vue?vue&type=script&lang=js"
export * from "./certificateTypeManager.vue?vue&type=script&lang=js"
import style0 from "./certificateTypeManager.vue?vue&type=style&index=0&id=4aa2874a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports